$(document).ready(function () {
    $(".slick-slider").slick({
        slidesToShow: 2,
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        autoplaySpeed: 2000,
        prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0835/6721/4904/files/left-arrow_abc7e5e2-a20c-4c4b-a3be-046162c73241.png?v=1698329978" alt="left-arrow" title="left-arrow" loading="lazy"/></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0835/6721/4904/files/right-arrow_97bf8b0e-a8e6-4bf1-bc15-c265b56c448b.png?v=1698329979" alt="right-arrow" title="right-arrow" loading="lazy"/></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".product-thumbnail .slider-content").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: false,
        autoplay: true,
        autoplaySpeed: 1000,
        // infinite: true,
        // speed: 1000,
        // asNavFor: ".slider-thumb",
    });

    $(".collection-filter-btn").click(function () {
        var tabID = $(this).attr("data-tab");
        $(this).addClass("active").siblings().removeClass("active");
        $("#tab-" + tabID)
            .addClass("active")
            .siblings()
            .removeClass("active");
    });

    $(function () {
        $(".accordion-content:not(:first-of-type) .accordion-content-text").css("display", "none");
        $(".accordion-content:first-of-type .accordion-title").addClass("open");

        $(".accordion-title").click(function () {
            $(".open").not(this).removeClass("open").next().slideUp(300);
            $(this).toggleClass("open").next().slideToggle(300);
        });
    });

  // Mobile Mega menu 
  
  // $(".child-btn-title").click(function() {
  //   $(this).addClass('hide-child-btn');
  //   $(this).siblings('a').addClass('hide-child-btn');
  //   $(this).siblings('.grand-child-wrap').addClass('show-grand-wrap');
  // });
  
  $(".child-btn-title").click(function() {
    $(this).addClass('hide-child-btn');
    $(this).closest('.second-slide-inner').find('.child-btn-title').addClass('hide-child-btn');
    $(this).next('.grand-child-wrap').addClass('show-grand-wrap');
  });

  $('.back-to-first-slide').click(function(){
    $(this).closest('.second-slide-inner').find('.child-btn-title').removeClass('hide-child-btn');
    // $(this).closest('.second-slide-inner').find('.child-btn-title').next('.child-btn-title').removeClass('hide-child-btn');
    $(this).closest('.grand-child-wrap').removeClass('show-grand-wrap');
  });
  $('.back-from-last-slide').click(function(){
    $(this).closest('.second-slide-inner').find('.child-btn-title').removeClass('hide-child-btn');
    $(this).closest('.grand-child-wrap').removeClass('show-grand-wrap');
  });
  $('.mobile-search-main a').click(function(){
    $('.mobile-section-wrap button').click(); 
  });
  $('.main-mobile-menu-btn').click(function(){
    $('.mobile-search-input-form').addClass('search-btn-toggle');
  });
  $('.open-last-slide').click(function(){
    $('.mobile-search-input-form').removeClass('search-btn-toggle');
  });
 
});












